/*
 * @Author: Ryan
 * @Date: 2026-01-13
 * @Description: TikTok Use Cases Section - 使用场景卡片展示
 */
import React from 'react';

import styles from './index.module.scss';

// 右箭头图标
const ArrowRightIcon = () => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M4.16669 10H15.8334M15.8334 10L10 4.16669M15.8334 10L10 15.8334"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export interface UseCaseItem {
  title: string;
  description: string;
}

export interface TikTokUseCasesSectionProps {
  /** 标题 */
  title: string;
  /** 用例列表 */
  useCases: UseCaseItem[];
  /** CTA 文本 */
  ctaText?: string;
  /** 点击链接回调 */
  onLearnMore?: (index: number) => void;
}

const TikTokUseCasesSection: React.FC<TikTokUseCasesSectionProps> = ({
  title,
  useCases,
  ctaText = 'Learn more',
  onLearnMore,
}) => {
  const handleLearnMore = (index: number) => {
    if (onLearnMore) {
      onLearnMore(index);
    }
  };

  return (
    <section className={styles.section}>
      <div className={styles.container}>
        {/* 标题 */}
        <h2 className={styles.title}>{title}</h2>

        {/* 卡片网格 */}
        <div className={styles.grid}>
          {useCases.map((useCase, index) => (
            <div key={index} className={styles.card}>
              <h3 className={styles.cardTitle}>{useCase.title}</h3>
              <p className={styles.cardDescription}>{useCase.description}</p>
              <button
                type="button"
                className={styles.learnMoreButton}
                onClick={() => handleLearnMore(index)}
              >
                <span>{ctaText}</span>
                <ArrowRightIcon />
              </button>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default TikTokUseCasesSection;
